import { brand } from '../../../theme/themePrimitives';
import CustomModal from '../../modals';
import { deleteFormThunk } from '../../../redux/thunks/form';
import { useParams } from 'react-router';
import { AppDispatch, RootState } from '../../../redux/store';
import { Box, Button, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

/**
 * @heading1: DeletePipelineModal
 * @paragraph: A modal component for confirming the deletion of a pipeline.
 * Displays a warning message and provides options to cancel or confirm the deletion.
 * @param: {boolean} open - Determines whether the modal is open.
 * @param: {function} onClose - Function to handle the modal close action.
 */

const DeleteFormModal = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
    /**
     * @heading3: Variables
     * @ol:
     * dispatch: {AppDispatch} - The Redux dispatch function to trigger actions.
     * loaders/selectedPipeline: An object containing the details from the Redux store.
     */
    const dispatch = useDispatch<AppDispatch>();
    const { id } = useParams<{ id: string }>();
    const { loaders, selectedForm } = useSelector((state: RootState) => state.form);

    /**
     * @heading3: Functions
     * @heaidng4: Handles the deletion of the pipeline.
     * @paragraph: Dispatches the deleteFormThunk to perform the deletion.
     */
    const removeIntegrationHandler = async () => {
        if (selectedForm?.id) {
            try {
                await dispatch(deleteFormThunk({ form_id: selectedForm.id, client_id: id ? parseInt(id as string, 10) : 0 })).unwrap();
                // Close the modal after successful deletion
                onClose();
            } catch (e) {
                // Catch Errors
            }
        }
    };

    return <CustomModal open={open} handleClose={loaders.isDeleting ? () => null : onClose} isError={true} title="Delete Forms">
        <Typography variant="subtitle1" align="center">Are you sure you want to delete <Typography component="span" variant="subtitle1" color={brand[300]}>{selectedForm?.title}</Typography> Form?</Typography>
        <Typography variant="subtitle2" align="center" color="textDisabled">* Forms and their Submissions once deleted cannot be retreived</Typography>
        {/* Action buttons */}
        <Box display="flex" gap={2} mt={2}>
            <Button variant="outlined" color="secondary" onClick={onClose} fullWidth disabled={loaders.isDeleting}>
                Cancel
            </Button>
            <Button type="submit" variant="contained" color="error" onClick={removeIntegrationHandler} fullWidth disabled={loaders.isDeleting}>
                {loaders.isDeleting ? 'Deleting...' : 'Delete'}
            </Button>
        </Box>
    </CustomModal>;
};

export default DeleteFormModal;